import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import PoliticaPrivacidade from './PoliticaPrivacidade';
import ManualUso from './ManualUso';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/manual-de-uso" element={<ManualUso />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;